import { create } from "zustand";

export const useMenuPermissionsStore = create((set) => ({
  menuPermissions: {},
  setMenuPermissions: (value) => set({ menuPermissions: value }),
}));
